import { render, staticRenderFns } from "./activation_step_two.vue?vue&type=template&id=6bf19508&scoped=true&"
import script from "./activation_step_two.vue?vue&type=script&lang=js&"
export * from "./activation_step_two.vue?vue&type=script&lang=js&"
import style0 from "./activation_step_two.vue?vue&type=style&index=0&id=6bf19508&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf19508",
  null
  
)

export default component.exports